/**
 * Accessibility enhancements (WCAG 3.2.5 — links opening a new window).
 * Appends a visually-hidden "(opens in new window)" to every target="_blank"
 * link that doesn't already announce it. Runs once on load and after DOM
 * mutations so app-injected links (slide cart, Klaviyo, etc.) are covered too.
 */
(function () {
  var NOTICE = '(opens in new window)';

  function annotate(root) {
    var links = (root || document).querySelectorAll('a[target="_blank"]:not([data-newwin-annotated])');
    links.forEach(function (a) {
      a.setAttribute('data-newwin-annotated', 'true');

      // Skip if the link already conveys it via aria-label or existing text.
      var aria = (a.getAttribute('aria-label') || '').toLowerCase();
      if (aria.indexOf('new window') !== -1 || aria.indexOf('new tab') !== -1) return;
      if ((a.textContent || '').toLowerCase().indexOf('new window') !== -1) return;

      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = ' ' + NOTICE;
      a.appendChild(span);

      // Security hardening for _blank links that lack it.
      var rel = a.getAttribute('rel') || '';
      if (rel.indexOf('noopener') === -1) {
        a.setAttribute('rel', (rel + ' noopener').trim());
      }
    });
  }

  function init() {
    annotate(document);
    if (!('MutationObserver' in window)) return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          annotate(document);
          break;
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
